import { gozokiApiWithAuth } from '../gozokiApi'

export type SensorAlertCategory = 'AMBIANT' | 'FRIGO' | 'CHAMBRE_FROIDE'

export interface SensorAlertSettingData {
  id: number
  category: SensorAlertCategory
  tempMin: number
  tempMax: number
  breachToleranceMinutes: number
  inactivityThresholdMinutes: number
  createdAt: string
  updatedAt: string
}

export const fetchAlertSettings = async () => {
  const response = await gozokiApiWithAuth.get<SensorAlertSettingData[]>('/sensors/alert-settings')
  return response.data
}
